import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import helperPlugin from "./helpers"
import firebase from "firebase";
import "@/firebase/";

import Autocomplete from "v-autocomplete";
import "v-autocomplete/dist/v-autocomplete.css";
Vue.use(Autocomplete);

import VCalendar from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";

Vue.use(helperPlugin)

Vue.use(VCalendar, {
  firstDayOfWeek: 2,
  formats: {
    title: "MMMM YYYY",
    weekdays: "W",
    navMonths: "MMM",
    input: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
    dayPopover: "L",
  },
  attributes: [
    {
      key: 'today',
      highlight: {
        backgroundColor: '#ff8080', // Red
        borderColor: '#ff6666',
        borderWidth: '2px',
        borderStyle: 'solid',
      },
      contentStyle: {
        color: '#fafafa',
      },
      dates: new Date(2018, 0, 1)
    }
  ],
});

import vSelect from 'vue-select'
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => {
      return createElement('i', {
        class: {
          far: true,
          "fa-times": true,
        },
        style: {
          fontSize: "16px",
          marginRight: "5px",
          color: "var(--color-danger)"
        }
      })
    },
  },
  OpenIndicator: {
    render: createElement => {
      return createElement('i', {
        class: {
          far: true,
          "fa-chevron-down": true,
        },
        style: {
          fontSize: "16px",
          padding: "0 5px",
          color: "var(--color-theme)"
        }
      })
    },
  },
});
Vue.component('v-select', vSelect)

Vue.config.productionTip = false;

let app = "";

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    store
      .dispatch('getCurrentUser', user)
      .then(() => {
        app = new Vue({
          router,
          store,
          data() {
            return {
              user: user
            };
          },
          render: h => h(App)
        }).$mount("#app");
      })
      .catch(error => {
        // Sign out if firebase is not accessible and show a error message
        store.commit("SET_CURRENT_USER", null)
        store.dispatch("setFlashMessage", error.message)
        firebase
          .auth()
          .signOut()
          .then(() => {
            router.push({ name: "login" });
          })
      });
  } else {
    if (!app) {
      /* eslint-disable no-new */
      app = new Vue({
        router,
        store,
        data() {
          return {
            user: user
          };
        },
        render: h => h(App)
      }).$mount("#app");
    }
  }
});

